import {
  CompanyTabLayout,
  EpsAndRevenueTable
} from 'modules';
import { useParams } from 'react-router-dom';



export const FC = () => {
  const params = useParams();

  return (
    <CompanyTabLayout.FC
      companyChart={(
        <EpsAndRevenueTable.FC
          companyId={params.companyId ?? ''}
          variant='tab'
        />
      )}
    />
  );
};
